<template>
  <div class="animated fadeIn profile-component main-div">
    <vLoading v-if="vLoading" />
    <div v-if="!notAllowed">
      <div v-if="loaded">
        <v-row class="pt-1">
          <v-col sm="6" cols="12">
            <div class="pt-1 fs-small">
              <router-link to="/map" class="no-underline">
                <span class="c-primary"> انتخاب استان </span>
              </router-link>
              <v-icon>mdi-chevron-left</v-icon>
              <span @click="goToMap('state')" class="pointer">
                استان {{ acceleratorInfo.state }}
              </span>
              <v-icon>mdi-chevron-left</v-icon>
              <span @click="goToMap('accelerator')" class="pointer">
                شتاب‌دهنده‌ها
              </span>
              <v-icon>mdi-chevron-left</v-icon>
              <span class="font-weight-bold">
                {{ acceleratorInfo.name }}
              </span>
            </div>
          </v-col>
          <v-col sm="6" cols="12" class="text-left">
            <v-btn
              @click="goToMap('state')"
              class="bc-primary text-white no-underline"
              elevation="0"
              ><span class="c-light">بازگشت به نقشه</span></v-btn
            >
          </v-col>
        </v-row>
        <v-row class="">
          <v-col cols="12" sm="12" md="12" lg="6" xl="6">
            <v-card class="common-card company-card">
              <v-row class="uni-header">
                <v-col cols="12" class="d-flex flex-column flex-sm-row">
                  <div class="view-imageBox">
                    <img
                      :src="
                        acceleratorInfo.avatar
                          ? acceleratorInfo.avatar
                          : 'https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcTasF2J01pp5zzTcs1-GtFdrelxnu331FtNs6jNP6LRwfLdIpw0zZEB7iOOf5NoPeKb_8g&usqp=CAU'
                      "
                    />
                  </div>
                  <div class="description-box px-5">
                    <h5 class="mt-1 c-dark fs-xxlarge">
                      {{ acceleratorInfo.name }}
                    </h5>
                    <p
                      v-if="acceleratorInfo.description"
                      class="c-grey fs-medium text-justify"
                    >
                      {{
                        acceleratorInfo.description.length > 180
                          ? acceleratorInfo.description.slice(0, 180) + "..."
                          : acceleratorInfo.description
                      }}
                    </p>
                    <p v-else class="c-grey fs-small">
                      توضیحی برای شتاب‌دهنده ثبت نشده است.
                    </p>
                  </div>
                </v-col>
              </v-row>
              <div
                v-if="acceleratorInfo.description.length > 220"
                class="text-left"
              >
                <v-btn
                  class="seeMore-btn"
                  @click="openSeeMoreModal('description')"
                  text
                >
                  <span class="c-primary">مشاهده بیشتر</span>
                </v-btn>
              </div>
            </v-card>
          </v-col>
          <v-col cols="12" sm="12" md="12" lg="6" xl="6">
            <v-card class="common-card card-height">
              <h5 class="mt-1 c-dark fs-xxlarge">اطلاعات تماس شتاب‌دهنده</h5>
              <div class="pt-2 c-grey">
                <v-icon class="ps-2">$Location</v-icon>

                <span class="fs-medium">
                  نشانی شتاب‌دهنده:
                  {{
                    acceleratorInfo.state +
                    ", " +
                    acceleratorInfo.city +
                    (acceleratorInfo.city ? ", " : "")
                  }}
                  {{ acceleratorInfo.address ? acceleratorInfo.address : "--" }}
                </span>
              </div>
              <div class="pt-4 c-grey">
                <v-icon class="ps-2">$Phone</v-icon>
                <span v-if="!acceleratorInfo.tel" class="fs-medium">
                  تلفن‌های تماس: --</span
                >
                <span class="fs-medium" v-else>
                  تلفن‌های تماس:
                  {{ acceleratorInfo.tel }}
                </span>
              </div>
              <div class="pt-4 c-grey">
                <v-icon class="ps-2">$Email</v-icon>
                <span v-if="!acceleratorInfo.email" class="fs-medium"
                  >ایمیل : --</span
                >
                <span class="fs-medium" v-else>
                  ایمیل :
                  {{ acceleratorInfo.email }}
                </span>
              </div>
              <div class="pt-4 c-grey">
                <v-icon class="ps-2">$Url</v-icon>
                <span class="fs-medium" v-if="acceleratorInfo.website">
                  آدرس‌‌ تارنما:
                  <a :href="checkWebsite()" target="_blank">{{
                    acceleratorInfo.website
                  }}</a>
                </span>
                <span class="fs-medium" v-else> آدرس‌‌ تارنما: -- </span>
              </div>
            </v-card>
          </v-col>
        </v-row>
        <v-row>
          <v-col cols="12" sm="12" md="12" lg="6" xl="6">
            <v-card class="common-card company-stretch card-height">
              <v-row>
                <v-col class="center-col">
                  <h5 class="mb-4 fs-xxlarge">محصولات</h5>
                  <v-spacer></v-spacer>
                  <h6 class="fs-large">
                    {{
                      acceleratorInfo.products.length
                        ? acceleratorInfo.products.length + " محصول"
                        : ""
                    }}
                  </h6>
                </v-col>
              </v-row>

              <div
                v-if="!acceleratorInfo.products.length"
                class="text-center mt-5"
              >
                <hr />
                <span> محصولی برای این شتاب‌دهنده به ثبت نرسیده است.</span>
                <hr />
              </div>
              <div v-else>
                <div v-if="acceleratorInfo.products.length > 3">
                  <div
                    v-for="(product, index) in acceleratorInfo.products.slice(
                      0,
                      3
                    )"
                    :key="index"
                    class="mb-3"
                  >
                    <li class="fs-medium c-grey">
                      <v-icon>mdi-circle-small</v-icon>
                      {{
                        product.title.length > 70
                          ? product.title.slice(0, 70) + "..."
                          : product.title
                      }}
                    </li>
                  </div>
                  <div class="text-left pt-3">
                    <v-btn
                      class="seeMore-btn"
                      @click="openSeeMoreModal('product')"
                      text
                    >
                      <span class="c-primary">مشاهده بیشتر</span>
                    </v-btn>
                  </div>
                </div>
                <div v-else>
                  <div
                    v-for="(product, index) in acceleratorInfo.products"
                    :key="index"
                    class="mb-3"
                  >
                    <li class="fs-medium c-grey">
                      <v-icon>mdi-circle-medium</v-icon>
                      {{
                        product.title.length > 70
                          ? product.title.slice(0, 70) + "..."
                          : product.title
                      }}
                    </li>
                  </div>
                  <div v-if="showProductMoreBtn" class="text-left pt-3">
                    <v-btn
                      class="seeMore-btn"
                      @click="openSeeMoreModal('product')"
                      text
                    >
                      <span class="c-primary">مشاهده بیشتر</span>
                    </v-btn>
                  </div>
                </div>
              </div>
            </v-card>
          </v-col>
          <v-col cols="12" sm="12" md="12" lg="6" xl="6">
            <v-card class="common-card company-stretch card-height">
              <v-row>
                <v-col class="">
                  <h5 class="mb-4 fs-xxlarge">موضوع شتاب‌دهنده</h5>
                </v-col>
              </v-row>

              <div v-if="!acceleratorInfo.catName" class="text-center mt-5">
                <hr />
                <span>موضوعی برای این شتاب‌دهنده به ثبت نرسیده است.</span>
                <hr />
              </div>
              <div v-else>
                <li class="fs-medium c-grey ms-2">
                <v-icon>mdi-circle-medium</v-icon>
                  {{ acceleratorInfo.catName }}
                </li>
              </div>
            </v-card>
          </v-col>
        </v-row>
        <v-row>
          <v-col v-if="type != 'mobile'">
            <v-card class="common-card company-stretch card-height mt-2">
              <v-card-title>
                <h5 class="fs-xxlarge">گالری تصاویر</h5>
              </v-card-title>
              <div
                v-if="!acceleratorInfo.gallery.length"
                class="px-5 text-center mb-16"
              >
                <hr />
                <span class="fs-small c-grey mx-auto">
                  تصویری برای این شتاب‌دهنده به ثبت نرسیده است.
                </span>
                <hr />
              </div>
              <v-row class="d-flex flex-column mt-2" v-else>
                <v-row>
                  <v-col
                    class="text-center img-col d-flex py-0"
                    sm="4"
                    md="4"
                    lg="2"
                    xl="2"
                    v-for="(img, index) in acceleratorInfo.gallery"
                    :key="index"
                  >
                    <img :src="img.url" class="gallery-img mb-2" />
                    <span class="fs-medium">{{
                      img.title.length > 20
                        ? img.title.slice(0, 20) + "..."
                        : img.title
                    }}</span>
                  </v-col>
                </v-row>
                <v-row class="justify-content-center mb-3">
                  <v-btn
                    :to="'/acceleratorImages/' + acceleratorId"
                    class="see-btn text-primary font-weight-bold"
                  >
                    <span> مشاهده همه تصاویر </span>
                    <v-icon large> mdi-chevron-left </v-icon>
                  </v-btn>
                </v-row></v-row
              >
            </v-card></v-col
          >
          <v-col v-if="type == 'mobile'">
            <v-card class="common-card company-stretch card-height mt-2">
              <v-card-title>
                <h5>گالری تصاویر</h5>
              </v-card-title>
              <div
                v-if="!acceleratorInfo.gallery.length"
                class="pa-5 text-center mb-16"
              >
                <hr />
                <span class="text-center mx-auto"
                  >تصویری برای این شتاب‌دهنده به ثبت نرسیده است.</span
                >
                <hr />
              </div>
              <div v-else>
                <v-row class="main-div">
                  <v-carousel
                    v-model="model"
                    hide-delimiters
                    :show-arrows="acceleratorInfo.gallery.length > 1"
                  >
                    <v-carousel-item
                      cycle
                      v-for="(img, index) in acceleratorInfo.gallery"
                      :key="index"
                      :src="img.url"
                      reverse-transition="fade-transition"
                      transition="fade-transition"
                      class="slider"
                    >
                    </v-carousel-item>
                  </v-carousel>
                </v-row>
                <v-row class="justify-content-center mt-4">
                  <v-btn
                    :to="'/acceleratorImages/' + acceleratorId"
                    class="see-btn text-primary font-weight-bold"
                  >
                    <span class="fs-large"> مشاهده همه تصاویر </span>
                    <v-icon large> mdi-chevron-left </v-icon>
                  </v-btn>
                </v-row>
              </div>
            </v-card></v-col
          >
        </v-row>
        <v-dialog v-model="seeMoreModal" width="600">
          <v-card v-if="seeMoreType == 'description'" class="modal-card">
            <v-container class="p-4">
              <v-row class="mb-1">
                <v-col class="text-right">
                  <h5 class="mt-1 c-dark fs-xxlarge">
                    {{ acceleratorInfo.name }}
                  </h5>
                </v-col>
                <v-col class="text-left">
                  <span @click="seeMoreModal = false">
                    <v-icon class="pointer">$Close</v-icon>
                  </span>
                </v-col>
              </v-row>

              <p
                class="c-grey fs-medium text-justify"
                style="line-height: 30px"
              >
                {{ acceleratorInfo.description }}
              </p>
            </v-container>
          </v-card>
          <v-card v-if="seeMoreType == 'product'" class="modal-card">
            <v-container class="p-4">
              <v-row class="mb-1">
                <v-col class="text-right">
                  <h5 class="mt-1 c-dark fs-xxlarge">محصولات</h5>
                </v-col>
                <v-col class="text-left">
                  <span @click="seeMoreModal = false">
                    <v-icon class="pointer">$Close</v-icon>
                  </span>
                </v-col>
              </v-row>

              <div class="products-box">
                <div
                  v-for="(product, index) in acceleratorInfo.products"
                  :key="index"
                  class="mb-5"
                >
                  <span class="c-grey fs-medium">
                    <v-icon class="pt-1 c-grey">mdi-circle-medium</v-icon>
                    {{ " " + product.title }}
                  </span>
                </div>
              </div>
            </v-container>
          </v-card>
        </v-dialog>
      </div>
    </div>
    <div v-else>
      <v-row class="p-1">
        <v-col sm="6" cols="12"> &nbsp; </v-col>
        <v-col sm="6" cols="12" class="text-left">
          <v-btn to="/map" class="bc-primary text-white no-underline"
            ><span class="c-light">بازگشت به نقشه</span></v-btn
          >
        </v-col>
      </v-row>
      <v-card class="mt-3">
        <v-container>
          <hr />
          <h5 class="text-center">
            دسترسی به اطلاعات این شتاب‌دهنده وجود ندارد
          </h5>
          <hr />
        </v-container>
      </v-card>
    </div>
  </div>
</template>

<script>
export default {
  components: {
    Chart,
  },
  data() {
    return {
      model: 0,
      acceleratorId: "",
      busy: true,
      value: 0,
      acceleratorInfo: {},
      list: [],
      loaded: false,
      notAllowed: false,
      type: "",
      isBusy: false,
      vLoading: false,
      seeMoreModal: false,
      seeMoreType: "",
    };
  },
  methods: {
    openSeeMoreModal(type) {
      this.seeMoreType = type;
      this.seeMoreModal = true;
    },
    goToMap(to) {
      this.$router.push("/map");
      if (to == "state") {
        localStorage.setItem("state", this.acceleratorInfo.state);
        localStorage.setItem("stateId", this.acceleratorInfo.stateId);
      } else if (to == "accelerator") {
        localStorage.setItem("state", this.acceleratorInfo.state);
        localStorage.setItem("stateId", this.acceleratorInfo.stateId);
        localStorage.setItem("item", "accelerator");
      }
    },
    getProfileInfo() {
      if (window.screen.width < 850) {
        this.type = "mobile";
      } else {
        if (document.body.clientWidth < 850) {
          this.type = "mobile";
        } else {
          this.type = "desktop";
        }
      }

      this.isBusy = true;
      this.vLoading = true;
      this.$http
        .post(
          this.baseUrl + "/setad/public/accelerator/getInfo",
          {
            acceleratorId: this.$route.params.id,
          },
          {
            headers: {
              Authorization: "Bearer: " + localStorage.getItem("userId"),
            },
          }
        )
        .then((res) => {
          this.acceleratorInfo = res.data;
          this.vLoading = false;
          this.loaded = true;
        })
        .catch((err) => {
          this.vLoading = false;
          if (err.response.status == 403) {
            this.notAllowed = true;
          } else {
            console.log(err);
            this.toast(err.response.data, "error");
          }
        });
    },
    checkWebsite() {
      if (
        this.acceleratorInfo.website.indexOf("http://") == 0 ||
        this.acceleratorInfo.website.indexOf("https://") == 0
      ) {
        return this.acceleratorInfo.website;
      } else {
        return "//" + this.acceleratorInfo.website;
      }
    },
  },
  computed: {
    showProductMoreBtn() {
      let temp;
      temp = this.acceleratorInfo.products.filter((x) => x.title.length > 70);
      if (temp.length) {
        return true;
      } else {
        return false;
      }
    },
  },
  mounted() {
    this.acceleratorId = this.$route.params.id;
    this.getProfileInfo();
  },
};
</script>
<style lang="scss">
.modal-card {
  .mehvars-box,
  .products-box {
    margin: 5px 0;
    max-height: 450px;
    overflow-y: auto;
    &::-webkit-scrollbar {
      width: 8px;
    }

    &::-webkit-scrollbar-track {
      background-color: #eee;
      opacity: 0.5;
      border-radius: 10px;
    }

    &::-webkit-scrollbar-thumb {
      background-color: #bdbdbd;
      width: 10px;
      border-radius: 10px;
    }
  }
}
</style>
